export const Logo = ({ className = "h-10 w-10", testid = "brand-logo" }) => (
  <img
    src="/logo.png"
    alt="Pallet Works Logistic logo"
    data-testid={testid}
    className={`${className} rounded-full object-cover shrink-0 bg-white`}
  />
);
